import { map, takeUntil } from 'rxjs';

import { AtruviaPromiseService, type AtruviaPromises } from './async.utilts';

/** Extract easy to use consent data from Atruvia ConsentInformation. */
const fromConsentInformation = (value: ConsentInformation['consentInformation']) =>
  value.reduce<Record<ConsentCategory, boolean>>((dict, { name, value }) => {
    return { ...dict, [name]: value };
  }, {} as never);

/**
 * Watch user cookie consent through official Atruvia API.
 */
export class ConsentObserver {
  #consentInformationService;

  get destroy$() {
    return this.#consentInformationService.destroy$;
  }

  get state() {
    const state = this.#consentInformationService.state();
    return state ? fromConsentInformation(state) : null;
  }

  get state$() {
    return this.#consentInformationService.stateSubject$.pipe(
      map(value => fromConsentInformation(value)),
      takeUntil(this.#consentInformationService.destroy$)
    );
  }

  constructor(
    private logger = this.window.console,
    private window = self
  ) {
    const promises = {
      init: this.window.publicApi.consent.getConsent,
      concurrent: this.window.publicApi.consent.getNextConsent,
    } satisfies AtruviaPromises<unknown>;

    this.#consentInformationService = new AtruviaPromiseService(promises);
  }

  public init() {
    this.state$.subscribe({
      next: value => this.logger.debug('[Consent]', value),
      error: err => this.logger.error('[Consent]', err),
      complete: () => this.logger.debug('[Consent]', '🏁 stopped watching consent'),
    });

    return this;
  }
}
